
<figure class="brand-header">
	<header class="brand-wrapper">
		<app-icon class="brand" name="logo_thin" [shadow]="true"></app-icon>
		<span class="header">
			<h1>My na to máme</h1>
			<h2>portál moderního vzdělávání</h2>
		</span>
		<p class="slogan">Učitele vnímáme jako tvůrce společnosti.<br />
				Pohled do učebny je pohledem do naší budoucnosti.</p>
	</header>
</figure>

<article class="main-content" *ngIf="(routes$ | push) as  routes">

	<span class="promoted-header">
		<button class="button promoted link">
			<a class="route-link" [routerLink]="'/komunita/pro-ukrajinu'" >
				<app-icon name="ukrajinu" [shadow]="true"></app-icon>
				<div class="label">
					<span>Pro Ukrajinu</span>
					<span class="under-line-container" ></span>
				</div>
			</a>
		</button>
	</span>

	<section class="dinamic-offer">
		<app-data 
			[displayPage]="true"
			[dataSource]="{storeName: '/recommended', id: '', static: true}"
		>
			<ng-template 
				#optionTemplate 
				let-articles$="articles$"
				let-count$="count$" 
				let-status$="status$"
				let-pageParams$="pageParams$"
				let-displayPage="displayPage"
				let-scrollInToView$="scrollInToView$"
			>
				<app-loader class="loader" [status$]="status$"></app-loader>

				<div class="header">
					<app-icon class="filter-icon" name="filter" [shadow]="false"></app-icon>
					<span>doporučujeme</span>
				</div>
				<app-grid 
					[articles$]="articles$" 
					[displayPage]="displayPage"
					[queryParams$]="queryParams$"
					[orphan]="true"
				></app-grid>
			</ng-template>			
		</app-data>
	</section>

	<section class="main-section" *ngFor="let section of routes">
		<app-media 
			class="poster" 
			kind="screen" 
			[alt]="section.entityLabel" 
			[src]="section.fieldPoster!.url" 
			loading="eager"
		></app-media>
		<div class="section-wrapper">
			<app-page-header class="page-header" *ngIf="section" [page]="section"></app-page-header>
			<div class="cards-wrapper" [ngClass]="section.entityUrl.path.replace('/', '')" >

				<app-card-big 
					*ngFor="let page of section.children" 
					class="card-wrapper" 
					[item]="page"
					kind="home"
				></app-card-big>

			</div>	
		</div>
	</section>
</article>


<app-page-bottom></app-page-bottom>



